import { IOption } from '@r1-frontend/ui-react/components/select/select';

import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export type TSelectEmail = IAction<EPaymentActions.SELECT_EMAIL, IOption<string>>

const selectEmail = (emailOption: IOption<string>): TSelectEmail => ({
    type: EPaymentActions.SELECT_EMAIL,
    payload: emailOption,
});

export default selectEmail;
